import React from 'react';
import { LuBuilding2 } from "react-icons/lu";
import { IoBookOutline } from "react-icons/io5";
import { GoPeople } from "react-icons/go";

function Services() {
  return (
    <section id="services" className="bg-brand-cream py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-green mb-4">
             Your Contribution<br/><span className="italic text-gray-500">Will Help</span>
          </h2>
          <div className="w-12 h-0.5 bg-brand-green mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-16">

          {/* Card 1 */}
          <div className="bg-white group transition-all duration-500 hover:-translate-y-2 border border-gray-100 flex flex-col h-[28rem] overflow-hidden">
            <div className="flex-1 p-10 flex flex-col items-center text-center justify-center relative">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-green transform origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100"></div>
              <span className="text-5xl text-brand-green mb-8"><LuBuilding2/></span>
              <h3 className="text-2xl font-serif text-gray-900 mb-4">Prayer Space</h3>
              <p className="text-gray-500 font-sans leading-relaxed px-4">
                Create a beautiful and peaceful space for daily prayer and Friday Jumu'ah.
              </p>
            </div>
            <div className="bg-gray-50 py-4 text-center">
              <span className="text-xs font-sans tracking-widest uppercase text-gray-400 font-semibold group-hover:text-brand-green transition-colors">Learn More</span>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white group transition-all duration-500 hover:-translate-y-2 border border-gray-100 flex flex-col h-[28rem] overflow-hidden">
            <div className="flex-1 p-10 flex flex-col items-center text-center justify-center relative">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-green transform origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100"></div>
              <span className="text-5xl text-brand-green mb-8"><GoPeople/></span>
              <h3 className="text-2xl font-serif text-gray-900 mb-4">Community Center</h3>
              <p className="text-gray-500 font-sans leading-relaxed px-4">
                Provide a gathering space for Islamic education, events, and community programs.
              </p>
            </div>
            <div className="bg-gray-50 py-4 text-center">
              <span className="text-xs font-sans tracking-widest uppercase text-gray-400 font-semibold group-hover:text-brand-green transition-colors">Get Involved</span>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white group transition-all duration-500 hover:-translate-y-2 border border-gray-100 flex flex-col h-[28rem] overflow-hidden">
            <div className="flex-1 p-10 flex flex-col items-center text-center justify-center relative">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-green transform origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100"></div>
              <span className="text-5xl text-brand-green mb-8"><IoBookOutline/></span>
              <h3 className="text-2xl font-serif text-gray-900 mb-4">Facilities</h3>
              <p className="text-gray-500 font-sans leading-relaxed px-4">
                Build essential facilities which could include wudu areas, classrooms, etc.
              </p>
            </div>
            <div className="bg-gray-50 py-4 text-center">
              <span className="text-xs font-sans tracking-widest uppercase text-gray-400 font-semibold group-hover:text-brand-green transition-colors">See Details</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Services;
